import React from 'react';
import {observer} from 'mobx-react';
import {OddsTooltip} from "../../../odds/tooltip/odds-tooltip";
import {PredictionOddsTrends} from "./prediction.odds.trend";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";
import classnames from "classnames";
import {OptionCurrentRate} from "../../../option-rates/option-current-rate.js";
import {OptionPreMatchRate} from "../../../option-rates/option-pre-match-rate";
import {Link} from "../../../link/link";
import {LINK_REL} from "../../../../consts";

export const PredictionOddsTooltip = observer(({
                                                 option,
                                                 controller,
                                                 isSelected,
                                                 onClick,
                                                 bookmaker,
                                                 bookieHrefModel,
                                                 betsImpressionParams,
                                                 isFirst,
                                                 isLast,
                                                 className,
                                                 showOriginalOdds,
                                                 showPreGameRates,
                                                 shouldHideTrend
                                               }) => {
  if(!option) {
    return null;
  }

  const {state} = controller;
  const {game} = state;

  const canClickBookie = !!(bookieHrefModel && onClick);

  const linkProps = {
    onClick: canClickBookie ? () => onClick() : undefined,
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(
      className,
      styles.odds_cell,
      {[styles.odds_cell_first]: isFirst},
      {[styles.odds_cell_last]: isLast},
      {[styles.odds_cell_active]: isSelected}),
  }

  const tooltipProps = {
    bookmaker,
    option,
    controller,
    bookieHrefModel,
    betsImpressionParams,
    showOriginalOdds: showOriginalOdds,
    className: classNames(
      className,
      styles.odds_cell,
      {[styles.odds_cell_first]: isFirst},
      {[styles.odds_cell_last]: isLast},
      {[styles.odds_cell_active]: isSelected}),
    onClick: canClickBookie ? () => onClick() : undefined,
    disable: !canClickBookie,
  }

  const rateProps = {
    option,
    controller,
    betsImpressionParams,
    className: classnames(styles.odds_text, {
      [styles.odds_text_active]: isSelected,
      [styles.long_value]: option.currentRateLength > 6
    })
  }

  const showPrematchRates = showPreGameRates && option.preMatchRates

  return (
    <OddsTooltip {...tooltipProps}>
      <Link {...linkProps}>
          {
              shouldHideTrend ?  <span>{"~"}</span> : <PredictionOddsTrends odds={option}/>
          }
        {
          game?.isEnded || showPrematchRates ? <OptionPreMatchRate {...rateProps}/> : <OptionCurrentRate {...rateProps}/>
        }
      </Link>
    </OddsTooltip>
  )
});
